//引入上边封装的axios文件
import request from "@/request";
import qs from "qs";  

// 用户获取验证码
export const getProvince = () => {
    return request({
        url: "/common/areainfo/provinceTree",
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
export const getLogistics = () => {
    return request({
        url: "/common/expressCompany/list",
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
export const addLogistics = data => {
    return request({
        url: "/supplier/freightTemplate/add",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
export const updateLogistics = data => {
    return request({
        url: "/supplier/freightTemplate/update",
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
        data
    });
};
export const logistics = (data) => {
    return request({
        url: "/supplier/freightTemplate/page?"+qs.stringify(data),
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
export const deletLogistics = (id) => {
    return request({
        url: `/supplier/freightTemplate/delete/${id}`,
        method: "POST",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};
export const logisticsDetail = (id) => {
    return request({
        url: `/supplier/freightTemplate/detail/${id}`,
        method: "GET",
        headers:{
            "content-type": "application/json;charset=UTF-8"
        },
    });
};